"use strict";

var _ = require('underscore');
var TransactionShipmentQuote = require('bunsen/models/ecomm/TransactionShipmentQuote');
var ShipmentQuotes = require('bunsen/collections/logistics/ShipmentQuotes');
var Party = require('bunsen/models/Party');
var Anchor = require('bunsen/models/Anchor');
var ShipmentQuote = require('bunsen/models/logistics/ShipmentQuote');
var assert = require('bunsen/helpers/assert');
var TransactionShipmentQuotes;

var root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};

/**
 * @class TransactionShipmentQuotes
 * @extends SoaCollection
 * @property {Offer} model {@link Offer}
 * @property {endpoints.offers} url -
 */
TransactionShipmentQuotes = root.bunsen.TransactionShipmentQuotes = ShipmentQuotes.extend({
    model: TransactionShipmentQuote,
    _newTransactionShipmentQuote: function (quoteAttrs, options) {
        var sq;
        options = _.defaults(options || {}, {
            add: true
        });
        quoteAttrs.billToRole = quoteAttrs.billToRole || quoteAttrs.authorRole;
        sq = new TransactionShipmentQuote(_.extend({
            type: ShipmentQuote.TYPE_TRANSACTION,
            pricingType: ShipmentQuote.PRICING_TYPE_COMMERCIAL,
            anchor: {
                sourceType: Anchor.TYPE_TRANSACTION,
                sourceId: this.getTransactionId()
            },
            handlingTime: {}
        }, quoteAttrs));

        if (options.add) {
            this.add(sq);
        }
        return sq;
    },
    /**
     * Returns new TransactionShipmentQuote with Dealer author/billTo
     * @param {object} [options]
     * @param {boolean} [options.add=true] Adds to collection instance
     * @returns {TransactionShipmentQuote}
     */
    newDealerTransactionShipmentQuote: function (options) {
        var quoteAttrs;
        var sq;
        assert(this.parents && this.parents[0], 'TransactionShipmentQuotes must be relation of Transaction');
        quoteAttrs = {
            author: { role: Party.ROLE_SELLER },
            billTo: { role: Party.ROLE_SELLER }
        };
        sq = this._newTransactionShipmentQuote(quoteAttrs, options);
        sq.set('serviceMethod', {});
        return sq;
    },
    /**
     * Returns new TransactionShipmentQuote with Internal author/billTo
     * @param {object} [options]
     * @param {boolean} [options.add=true] Adds to collection instance
     * @returns {TransactionShipmentQuote}
     */
    new1stdibsTransactionShipmentQuote: function (options, passedQuoteAttrs) {
        var quoteAttrs;
        assert(this.parents && this.parents[0], 'TransactionShipmentQuotes must be relation of Transaction');
        quoteAttrs = _.defaults({
            author: { role: Party.ROLE_INTERNAL },
            billTo: { role: Party.ROLE_INTERNAL }
        }, passedQuoteAttrs);
        return this._newTransactionShipmentQuote(quoteAttrs, options);
    },
    getTransactionId: function () {
        // This collection should only be a relation to a Transaction
        return this.parents[0].get('id');
    },
    _findByFunction: function (fn) {
        return this.find(function (quote) {
            return quote[fn]();
        });
    },
    _findActiveQuoteByFunction: function (fn) {
        return this.find(function (quote) {
            return quote[fn]() && quote.isActive();
        });
    },
    getPreQuote: function () {
        return this._findActiveQuoteByFunction('isPreQuote');
    },
    getDealerQuote: function () {
        return this._findActiveQuoteByFunction('isDealerBilledQuote');
    },
    get1stdibsQuote: function () {
        return this._findActiveQuoteByFunction('is1stdibsQuote');
    },
    getActiveAccountingQuote: function () {
        return this._findByFunction('isActiveAccountingQuote');
    },
    getRejectedAccountingQuote: function () {
        return this._findByFunction('isRejectedAccountingQuote');
    },
    getActiveAccountingQuoteSubTotal: function (currency) {
        var quote = this.getActiveAccountingQuote();
        if (quote) {
            return quote.getSubTotal(currency);
        }
        return null;
    },
    getActiveAccountingQuoteTotal: function (currency) {
        var quote = this.getActiveAccountingQuote();
        if (quote) {
            return quote.getTotalAmount(currency);
        }
        return null;
    },
    hasPreQuote: function () {
        return !!this.getPreQuote();
    },
    hasPreQuoteIncludingCanceled: function () {
        return !!this._findByFunction('isPreQuote');
    }
});

module.exports = TransactionShipmentQuotes;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/ecomm/TransactionShipmentQuotes.js
// module id = 78
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55